"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var createSchemaBridge_1 = tslib_1.__importDefault(require("uniforms/createSchemaBridge"));

var JSONSchemaBridge_1 = tslib_1.__importDefault(require("./JSONSchemaBridge")); // Register bridge.


createSchemaBridge_1["default"].register(JSONSchemaBridge_1["default"]);